import React, { useEffect } from 'react';
import EsatLandingPage from '../../features/specialty/esat';

export default function EsatLandingRoute() {
  useEffect(() => {
    document.title = "ESAT Prep 2026/2027 — Engineering & Science Admissions Test | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <EsatLandingPage />;
}
